import { Menu, rem } from "@mantine/core"
import { IconBooks, IconMail, IconMessageCircle, IconScript } from "@tabler/icons-react"

import { NavbarButtonWithMenu } from "@/components/generic/SideNavBar/components/NavbarButtonWithMenu/NavbarButtonWithMenu"
import Link from "next/link"
import { useTranslations } from "next-intl"

interface NavbarTemplatesButtonProps {
  isSelected: boolean
  showSequenceFeature?: boolean
  label: string
}

export function NavbarTemplatesButton({ isSelected, showSequenceFeature, label }: NavbarTemplatesButtonProps) {
  const t = useTranslations("sideNavBar")

  return (
    <NavbarButtonWithMenu icon={IconBooks} isSelected={isSelected} label={label}>
      <Menu.Dropdown miw={200}>
        {/* <Menu.Label>Application</Menu.Label> */}
        <Menu.Item leftSection={<IconMail style={{ width: rem(14), height: rem(14) }} />} component={Link} href="/templates/email/library">
          {t("templates.emailTemplates")}
        </Menu.Item>
        <Menu.Item
          component={Link}
          href="/templates/sms/library"
          leftSection={<IconMessageCircle style={{ width: rem(14), height: rem(14) }} />}
          // onClick={() => handleClick("/templates/sms/library")}
        >
          {t("templates.smsTemplates")}
        </Menu.Item>
        {showSequenceFeature && (
          <Menu.Item
            component={Link}
            href="/call/scripts"
            leftSection={<IconScript style={{ width: rem(14), height: rem(14) }} />}
            // onClick={() => handleClick("/call/scripts")}
          >
            {t("templates.callScripts")}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </NavbarButtonWithMenu>
  )
}
